import { render, staticRenderFns } from "./policy.poddisruptionbudget.vue?vue&type=template&id=9df8757e&"
import script from "./policy.poddisruptionbudget.vue?vue&type=script&lang=js&"
export * from "./policy.poddisruptionbudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports